<template>
  <div v-if="field" class="mb-4">
    <ValidationProvider
      :rules="field.type === 'session_radio' ? '' : field.validation"
      :name="field.label"
      ref="provider"
      v-slot="{ errors }"
    >
      <label
        v-if="isText || field.type === 'select'"
        class="malle-label"
        v-html="field.label"
      ></label>

      <input
        v-if="isText"
        :type="field.type"
        class="malle-input"
        :class="{ 'is-invalid': errors.length > 0 }"
        v-model="model"
      />

      <div v-else-if="field.type === 'session_radio'" class="malle-session-container">
        <div class="day-box-malle">
          <div class="day-title-malle" v-html="field.label"></div>

          <div class="slots-grid-malle">
            <label
              v-for="opt in field.options"
              :key="opt.value"
              class="slot-item"
              :class="{ 'disabled-slot': opt.available === false }"
            >
              <input
                type="radio"
                :value="opt.value"
                v-model="model"
                name="session_choice"
                :disabled="opt.available === false"
              />
              <div
                class="slot-pill-malle"
                :class="{'sold-out': opt.available === false}"
              >
                {{ opt.label }}
                <span v-if="opt.available === false" class="d-block tiny-text">SOLD OUT</span>
              </div>
            </label>
          </div>
        </div>
      </div>

<div v-else-if="field.name === 'privacy'" class="privacy-malle-box">
  <div v-for="opt in field.options.filter(o => o.label !== 'N/A')" :key="opt.value" class="d-flex align-items-start">
    <input
      type="checkbox"
      :id="'priv-' + opt.value"
      class="malle-checkbox me-2"
      :true-value="opt.value"
      false-value="0"
      v-model="model"
    />
    <label class="privacy-label-malle privacy-font" :for="'priv-' + opt.value">
      Dichiaro di aver letto e accettato la <strong><a href="https://www.elcompanies.com/en/privacy/consumer-privacy-policy/privacy-policy-sdk-pages-holder/italy-all-brands-consumer-privacy-policy-italian#otnotice-section-bc4a8762-313c-4bed-8e82-f30ae1511975" target="_blank">Privacy Policy</a></strong>.
    </label>
  </div>
</div>

      <transition name="fade">
        <span class="error-malle-msg" v-if="errors.length > 0 && field.type !== 'session_radio'">
          {{ errors[0] }}
        </span>
      </transition>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: 'DynamicField',
  props: ['field', 'value'],
  watch: {
    value (newVal) {
      if (this.field.type === 'session_radio' && !newVal) {
        this.$refs.provider.reset()
      }
    }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) {
        this.$emit('input', val)
        if (this.field.type === 'session_radio' && val) {
          this.$emit('session-selected', { fieldName: this.field.name, value: val })
          this.$refs.provider.reset()
        }
      }
    },
    isText () { return ['text', 'email', 'number'].includes(this.field.type) }
  }
}
</script>

<style scoped>
/* (Lo stile rimane identico a quello precedente) */
.malle-label { display: block; font-weight: bold; text-transform: uppercase; font-size: 12px; margin-bottom: 5px; text-align: left; color: #000; }
.malle-input { border: none !important; border-bottom: 1px solid #000 !important; border-radius: 0 !important; width: 100%; padding: 8px 0; margin-bottom: 5px; background: transparent !important; outline: none; }
.malle-session-container { flex: 1; min-width: 250px; height: 100%; }
.day-box-malle { border: 2px solid #da291c; border-radius: 25px; padding: 20px; background: #fff; height: 100%; display: flex; flex-direction: column; transition: all 0.3s; }
.day-title-malle { font-weight: bold; font-size: 14px; margin-bottom: 20px; text-align: center; min-height: 40px; display: flex; align-items: center; justify-content: center; text-transform: uppercase; }
.slots-grid-malle { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-top: auto; }
.slot-item { cursor: pointer; position: relative; margin-bottom: 0; }
.slot-item input { position: absolute; opacity: 0; width: 0; height: 0; }
.slot-pill-malle { background-color: #da291c; color: #fff; border-radius: 50px; padding: 12px 5px; font-weight: bold; font-size: 12px; text-align: center; transition: all 0.2s ease; border: 1px solid transparent; }
.slot-item input:checked + .slot-pill-malle { background-color: #000 !important; color: #fff; }
.disabled-slot { cursor: not-allowed !important; }
.slot-pill-malle.sold-out { background-color: #d3d3d3 !important; color: #fff !important; opacity: 0.7; pointer-events: none; }
.tiny-text { font-size: 8px; display: block; line-height: 1; margin-top: 2px; }
.privacy-label-malle { font-size: 11px; text-align: left; line-height: 1.4; color: #000; }
.malle-checkbox { width: 18px; height: 18px; accent-color: #da291c; }
.error-malle-msg { display: block; color: #da291c; font-size: 10px; font-weight: bold; text-transform: uppercase; margin-top: 5px; text-align: left; }
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }
.privacy-font {font-size:20px!important}
@media (max-width: 991px) { .malle-session-container { width: 100%; margin-bottom: 15px; } }
</style>
